export const SOFTLINE_API_KOPFAU_ENTITIES = 'v1/feichtinger/goldschmiede/kopfau/entities';

export const SOFTLINE_API_KOPFAU_START =
  'v1/feichtinger/goldschmiede/kopfau/entities/{id}/start';
export const SOFTLINE_API_KOPFAU_STOP =
  'v1/feichtinger/goldschmiede/kopfau/entities/{id}/stop';

export const SOFTLINE_API_KOPFAU_START_NEW = '/v1/timereport/stop';
export const SOFTLINE_API_KOPFAU_STOP_NEW = '/v1/timereport/stop';
export const SOFTLINE_API_GOLDSCHMIEDE_STOP_ALL = 'v1/feichtinger/goldschmiede/stopall';

export const SOFTLINE_API_KOPFAU_ABSCHLUSS =
  'v1/feichtinger/goldschmiede/kopfau/entities/{id}/abschluss';
export const SOFTLINE_API_KOPFAU_GOLDSCHMIEDE_ASSIGN =
  '/v1/feichtinger/goldschmiede/kopfau/assign';

export const SOFTLINE_API_BELEGVERMERK_ENTITIES =
  'v1/feichtinger/goldschmiede/kopfau/entities/{{idkopfau}}/belegvermerk/entites';
export const SOFTLINE_API_BEWEAU_ENTITIES =
  'v1/feichtinger/goldschmiede/kopfau/entities/{{idkopfau}}/beweau/entites';
export const SOFTLINE_API_BEWEAU_PICTURE = 'v1/artstamm/entities/{{id}}/bilder/entities';
export const SOFTLINE_API_BEWEAU_LOAD_PICTURE = 'v2/file/{{archiveKey}}';
export const SOFTLINE_API_TIME_REPORT = '/v1/timereport/entities';
export const SOFTLINE_API_TIME_REPORT_START_STOP = '/v1/timereport';

export const SOFTLINE_API_KOPFAU_SCAN_ADD = '/v1/belege/scan/{{labelType}}/{{code}}';
